// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paid-membership-plan-change[data-v-46d3b2ff]{padding-bottom:30px;padding-top:30px}.paid-membership-plan-change .caption[data-v-46d3b2ff]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
